// extracted by mini-css-extract-plugin
module.exports = {"payment-types":"PaymentTypes_payment-types__1BvtT","payment":"PaymentTypes_payment__3zhbN"};